import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { withViewport } from '../../util/contextHelpers';

import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  ExternalLink,
  NamedLink,
  ContactPreFooter,
} from '../../components';
import heroImage from '../../assets/fundis-success-story-banner.webp';

import quoteImg from '../../assets/fundis-success-story-quote.webp';

import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import css from './SuccessStoryFundisPage.css';

export const SuccessStoryFundisPageComponent = props => {
  const { intl, scrollingDisabled, viewport } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const schemaTitle = intl.formatMessage({ id: 'SuccessStoryFundis.schemaTitle' });
  const schemaDescription = intl.formatMessage({
    id: 'SuccessStoryFundis.schemaDescription',
  });

  const handleShowSpaceHome = () => {
    if (typeof window === 'object') {
      window.Intercom('showSpace', 'home');
    }
  };

  const MAX_MOBILE_SCREEN_WIDTH = 962;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="SuccessStoryFundisPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroSection}>
            <div className={css.heroSectionLeft}>
              <div className={css.heroSectionBreadcrumbs}>
                <NamedLink name="SuccessStoriesPage">
                  <FormattedMessage id="SuccessStoryFundis.heroBreadcrumbs1" />
                </NamedLink>
                <FormattedMessage id="SuccessStoryFundis.heroBreadcrumbs2" />
                <FormattedMessage id="SuccessStoryFundis.heroBreadcrumbs3" />
              </div>
              {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                <div className={css.heroSectionMobile}>
                  <img
                    src={heroImage}
                    alt="Hero"
                    className={css.proInfoSectionContentImage}
                    loading="lazy"
                  />
                </div>
              ) : null}
              <div className={css.heroSectionTitle}>
                <FormattedMessage id="SuccessStoryFundis.heroTitle" />
              </div>
              <div className={css.heroSectionText}>
                <FormattedMessage id="SuccessStoryFundis.heroText" />
              </div>
              <div className={css.heroSectionTags}>
                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStoryFundis.heroTag1" />
                </div>

                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStoryFundis.heroTag2" />
                </div>
              </div>
            </div>
            {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
              <div className={css.heroSectionRight}>
                <img
                  src={heroImage}
                  alt="Hero"
                  className={css.proInfoSectionContentImage}
                  loading="lazy"
                />
              </div>
            ) : null}
          </div>
          <div className={css.sections}>
            <div className={css.contentSection}>
              <div className={css.contentSectionContent}>
                <div>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryFundis.contentSectionParagraph11"
                        values={{
                          a: chunks => (
                            <a
                              href="https://fundis.fi/"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1683A3', fontWeight: 600 }}
                            >
                              {chunks}
                            </a>
                          ),
                        }}
                      />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph12" />
                    </p>
                  </article>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionTitle2" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph21" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph22" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph23" />
                    </p>
                  </article>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionTitle3" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph31" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryFundis.contentSectionParagraph32"
                        values={{
                          a: chunks => (
                            <a
                              href="https://freedomly.io/freelancer/markkinointi"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1683A3', fontWeight: 600 }}
                            >
                              {chunks}
                            </a>
                          ),
                        }}
                      />
                    </p>
                  </article>
                  <div className={css.articleBlockWithBGWithImage}>
                    <img
                      src={quoteImg}
                      alt="Seppo Kuusinen"
                      className={css.articleBlockWithBGWithImageImage}
                      loading="lazy"
                    />
                    <div className={css.articleBlockWithBGWithImageContent}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph33Quote" />
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph33Name" />
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph33Company" />
                    </div>
                  </div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionTitle4" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph41" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph42" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph43" />
                    </p>
                  </article>
                  <div className={css.articleBlockWithBGWithImage}>
                    <img
                      src={quoteImg}
                      alt="Seppo Kuusinen"
                      className={css.articleBlockWithBGWithImageImage}
                      loading="lazy"
                    />
                    <div className={css.articleBlockWithBGWithImageContent}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph44Quote" />
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph44Name" />
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph44Company" />
                    </div>
                  </div>
                  {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                    <div className={css.contentSectionCTAmobile}>
                      <div className={css.contentSectionCTAtitle}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                      </div>
                      <div className={css.contentSectionCTAtext}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                      </div>
                      <div className={css.contentSectionCTAbutton}>
                        <ExternalLink
                          className={css.contentSectionContactButton}
                          onClick={handleShowSpaceHome}
                        >
                          <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                        </ExternalLink>
                      </div>
                    </div>
                  ) : null}
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionTitle5" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph51" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph52" />
                    </p>
                  </article>
                  <div className={css.articleBlockWithBGWithImage}>
                    <img
                      src={quoteImg}
                      alt="Seppo Kuusinen"
                      className={css.articleBlockWithBGWithImageImage}
                      loading="lazy"
                    />
                    <div className={css.articleBlockWithBGWithImageContent}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph53Quote" />
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph53Name" />
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph53Company" />
                    </div>
                  </div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionTitle6" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph61" />
                    </p>
                  </article>
                  <div className={css.articleBlockWithBGWithImage}>
                    <img
                      src={quoteImg}
                      alt="Seppo Kuusinen"
                      className={css.articleBlockWithBGWithImageImage}
                      loading="lazy"
                    />
                    <div className={css.articleBlockWithBGWithImageContent}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph62Quote" />
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph62Name" />
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph62Company" />
                    </div>
                  </div>
                  <article>
                    <h2 className={css.listTitle}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionListTitle6" />
                    </h2>
                    <ul className={css.successStoryItemList}>
                      <li className={css.successStoryListItem}>
                        <FormattedMessage id="SuccessStoryFundis.contentSectionListItem61" />
                      </li>
                      <li className={css.successStoryListItem}>
                        <FormattedMessage id="SuccessStoryFundis.contentSectionListItem62" />
                      </li>
                      <li className={css.successStoryListItem}>
                        <FormattedMessage id="SuccessStoryFundis.contentSectionListItem63" />
                      </li>
                      <li className={css.successStoryListItem}>
                        <FormattedMessage id="SuccessStoryFundis.contentSectionListItem64" />
                      </li>
                      <li className={css.successStoryListItem}>
                        <FormattedMessage id="SuccessStoryFundis.contentSectionListItem65" />
                      </li>
                      <li className={css.successStoryListItem}>
                        <FormattedMessage id="SuccessStoryFundis.contentSectionListItem66" />
                      </li>
                    </ul>
                  </article>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionTitle7" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionParagraph71" />
                    </p>
                  </article>
                  <div className={css.articleSectionResults}>
                    <div className={css.articleSectionResultsTitle}>
                      <FormattedMessage id="SuccessStoryFundis.contentSectionResultsTitle" />
                    </div>
                    <ul className={css.articleSectionResultsList}>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage
                          id="SuccessStoryFundis.contentSectionResultsListItem1"
                          values={{
                            b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                          }}
                        />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage
                          id="SuccessStoryFundis.contentSectionResultsListItem2"
                          values={{
                            b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                          }}
                        />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage
                          id="SuccessStoryFundis.contentSectionResultsListItem3"
                          values={{
                            b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                          }}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
                <div className={css.contentSectionCTAbar}>
                  <div className={css.contentSectionCTA}>
                    <div className={css.contentSectionCTAtitle}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                    </div>
                    <div className={css.contentSectionCTAtext}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                    </div>
                    <div className={css.contentSectionCTAbutton}>
                      <ExternalLink
                        className={css.contentSectionContactButton}
                        onClick={handleShowSpaceHome}
                      >
                        <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                      </ExternalLink>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <ContactPreFooter />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

SuccessStoryFundisPageComponent.defaultProps = {
  scrollingDisabled: false,
};

const { number, shape } = PropTypes;

SuccessStoryFundisPageComponent.propTypes = {
  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired, // from injectIntl
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SuccessStoryFundisPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(SuccessStoryFundisPageComponent);

export default SuccessStoryFundisPage;
